import { Link } from 'react-router-dom';
import styles from './SiteFooter.module.css';

const productLinks = [
  { label: 'Platform', to: '/platform' },
  { label: 'Solutions', to: '/solutions' },
];

const companyLinks = [
  { label: 'Why NAATS', to: '/why-naats' },
  { label: 'Contact', to: '/contact' },
];

export function SiteFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.top}>
          <div>
            <Link to="/" className={styles.logoLink} aria-label="NAATS Home">
              <img src="/img/naats.png" alt="NAATS Group Inc." className={styles.logoImg} />
            </Link>
          </div>

          <div>
            <div className={styles.colTitle}>Product</div>
            <ul className={styles.colLinks}>
              {productLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className={styles.colLink}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className={styles.colTitle}>Company</div>
            <ul className={styles.colLinks}>
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className={styles.colLink}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={styles.bottom}>
          <p className={styles.copyright}>
            © {new Date().getFullYear()} NAATS. All rights reserved.
          </p>
          <div className={styles.legalLinks}>
            <Link to="/privacy" className={styles.legalLink}>Privacy Policy</Link>
            <Link to="/terms" className={styles.legalLink}>Terms of Service</Link>
            <Link to="/security" className={styles.legalLink}>Security</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
